/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Flex,
  Step,
  useSteps,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import {
  useEditLocation,
  useGetLocation,
  useGetLocationSlaDefaults,
} from "../../services/locations-apis";
import {
  useLookupCashCenterRoutes,
  useLookupCashCenters,
  useLookupCountries,
  useLookupCustomers,
  useLookupMachineMakers,
  useLookupMachineModel,
  useLookupMachineTypes,
} from "../../services/lookups-mutations";
import { useLookupCurrency } from "../../services/lookups-queries";
import { SERVICE_POINT_INFORMATION } from "./constants";
import Information from "./add-service-point/Information";
import { makeEditPayload } from "./utils";
import SiteSLAs from "./add-service-point/site-SLAs";
import ServiceWindow from "./add-service-point/service-windows";
import Denominations from "./add-service-point/denominations";
import SiteRepresentative from "./add-service-point/site-representative";
import Summary from "./add-service-point/summary";
import OnwardLocations from "./add-service-point/onwardLocations";
import ScheduledService from "./add-service-point/scheduled-service";

const steps = [
  { title: "Information" },
  { title: "Onward Locations" },
  // { title: "Cassettes" },
  { title: "Denominations" },
  { title: "Timings" },
  // { title: "Models" },

  { title: "Representatives" },
  { title: "Scheduled Services" },
];

export default function EditServicePoint() {
  const [triggerValidation, setTriggerValidation] = useState(false);
  const [servicePoint, setServicePoint] = useState({
    ...SERVICE_POINT_INFORMATION,
  });
  const navigate = useNavigate();
  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });
  const params = useParams();

  const {
    handleSubmit,
    control,
    watch,
    resetField,
    reset,
    setValue,
    getValues,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: { ...SERVICE_POINT_INFORMATION },
    mode: "onChange",
  });

  const { mutate: getLocationSlaDefaults, data: locationSlaDefaultsRes } =
    useGetLocationSlaDefaults();

  const [locationSlaDefaults, setLocationSlaDefaults] = useState(null);
  const {
    mutate: getCustomers,
    data: customerListRes,
    isPending: gettingCustomerList,
    // error: customerListError,
  } = useLookupCustomers();

  const {
    mutate: getMachineTypes,
    data: machineListRes,
    isPending: gettingMachineList,
    // error: machineListError,
  } = useLookupMachineTypes();

  const {
    mutate: getMakersList,
    data: makersListRes,
    isPending: gettingMakersList,
    // error: makersListError,
  } = useLookupMachineMakers();
  const {
    mutate: getModelsList,
    data: modelsListRes,
    isPending: gettingModelsList,
    // error: modelsListError,
  } = useLookupMachineModel();
  const {
    mutate: getCountries,
    data: countriesListRes,
    isPending: gettingCountriesList,
    // error: countriesListError,
  } = useLookupCountries();

  const {
    mutate: getCashCenter,
    data: cashCenterList,
    isPending: gettingCashCenterList,
    // error: cashCenterListError,
  } = useLookupCashCenters();
  const { data: routesListRes, isPending: gettingRoutesList } =
    useLookupCashCenterRoutes(watch("cashCenterId"));
  const {
    data: currencyListRes,
    isPending: gettingCurrencyList,
    // error: currencyError,
  } = useLookupCurrency();
  const {
    mutate: editRequest,
    isSuccess: isRequestEdited,
    // data: editRequestResponse,
    isPending: editingRequest,
  } = useEditLocation();
  const {
    mutate: getLocation,
    // isSuccess: isLocationAvailable,
    data: getLocationRes,
    isPending: gettingLocation,
    //     error: locationError,
    reset: locationReset,
  } = useGetLocation();

  useEffect(() => {
    if (!params?.locationId) return;

    getLocationSlaDefaults(params.locationId);
  }, [params?.locationId]);

  useEffect(() => {
    if (locationSlaDefaultsRes?.data) {
      setLocationSlaDefaults(locationSlaDefaultsRes.data);
    }
  }, [locationSlaDefaultsRes]);

  useEffect(() => {
    if (getLocationRes?.data && countriesListRes) {
      if (getLocationRes?.data.maker && !modelsListRes) {
        getModelsList(getLocationRes?.data.maker);
      } else if (currencyListRes && activeStep === 1) {
        const _data = getLocationRes.data;

        const _payload = {
          ...makeEditPayload(_data, currencyListRes?.data || []),
          firstServiceDate: _data.firstServiceDate
            ? new Date(_data.firstServiceDate)
            : null,
          decomissionedDate: _data.decomissionedDate
            ? new Date(_data.decomissionedDate)
            : null,
          lockInstallationDate: _data.lockInstallationDate
            ? new Date(_data.lockInstallationDate)
            : null,
          siteSLAs: _data.siteSLAs || [],
          followsCustomerSla: _data.followsCustomerSla || false,
        };

        setServicePoint(_payload);
        reset(_payload);
        locationReset();
      }
    }
  }, [
    getLocationRes,
    customerListRes,
    machineListRes,
    makersListRes,
    cashCenterList,
    countriesListRes,
    routesListRes,
    currencyListRes,
    modelsListRes,
  ]);

  useEffect(() => {
    if (isRequestEdited) {
      setActiveStep(1);
      navigate(Paths.locations);
    }
  }, [isRequestEdited]);

  useEffect(() => {
    getCashCenter();
    getCustomers();
    getMachineTypes();
    getCountries();
    getMakersList();
    if (params.locationId) {
      getLocation(params.locationId);
    }
  }, []);
  const addLocation = (data) => {
    const payload = { ...data };

    if (params.locationId) {
      editRequest({ ...payload, id: servicePoint.servicePointId });
    }
  };
  const getServicePointInformation = useMemo(
    () => ({
      customerId: servicePoint.customerId,
      billingCustomerId: servicePoint.billingCustomerId,
      billingCustomerName: servicePoint.billingCustomerName,
      contractCode: servicePoint.contractCode,
      cashCenterId: servicePoint.cashCenterId,
      cashCenterName: servicePoint.cashCenter,
      locationId: servicePoint.locationId,
      locationName: servicePoint.locationName,
      locationCode: servicePoint.locationCode,
      category: servicePoint.category,
      routeNo: servicePoint.routeNo,
      locationType: servicePoint.locationType,
      status: servicePoint.status,
      siteType: servicePoint.siteType,
      fixingSide: servicePoint.fixingSide,
      loadingSide: servicePoint.loadingSide,
      machineType: servicePoint.machineType,
      maker: servicePoint.maker,
      model: servicePoint.model,
      lockSerialNo: servicePoint.lockSerialNo,
      machineSerialNo: servicePoint.machineSerialNo,
      barcode: servicePoint.barcode,
      siteLimit: servicePoint.siteLimit,
      distanceFromBase: servicePoint.distanceFromBase,
      coLocatedGroupNo: servicePoint.coLocatedGroupNo,
      numberOfCassettes: servicePoint.numberOfCassettes,
      requiresCashierCount: servicePoint.requiresCashierCount,
      requiresEVhr: servicePoint.requiresEVhr,
      hasSecurityAlarm: servicePoint.hasSecurityAlarm,
      alarmDetails: servicePoint.alarmDetails,
      country: servicePoint.country,
      state: servicePoint.state,
      emirate: servicePoint.emirate,
      city: servicePoint.city,
      address: servicePoint.address,
      longitude: servicePoint.longitude,
      latitude: servicePoint.latitude,
      lockInstallationDate: servicePoint.lockInstallationDate,
      firstServiceDate: servicePoint.firstServiceDate,
      decomissionedDate: servicePoint.decomissionedDate,
      followStandardModels: servicePoint.followStandardModels,
      followStandardDenominations: servicePoint.followStandardDenominations,
      followStandardCassettes: servicePoint.followStandardCassettes,
      dedicatedSerials: servicePoint.dedicatedSerials,
      serviceDays: servicePoint.serviceDays,
      allowedDays: servicePoint.allowedDays,
      numberOfBins: servicePoint.numberOfBins || 0,
      numberOfKeys: servicePoint.numberOfKeys || 0,
      hasCamera: servicePoint.hasCamera || 0,
      cameraType: servicePoint.cameraType || "",
      area: servicePoint.area || "",
      machineInstallationDate:
        servicePoint.machineInstallationDate || new Date(),
    }),
    [servicePoint],
  );
  const updateServicePointInformation = (information) => {
    const _servicePoint = {
      customerId: information.customerId,
      billingCustomerId: information.billingCustomerId,
      billingCustomerName: information.billingCustomerName,
      contractCode: information.contractCode,
      cashCenterId: information.cashCenterId,
      cashCenterName: information.cashCenterName,
      locationId: information.locationId,
      locationName: information.locationName,
      locationCode: information.locationCode,
      category: information.category,
      routeNo: information.routeNo,
      locationType: information.locationType,
      status: information.status,
      siteType: information.siteType,
      fixingSide: information.fixingSide,
      loadingSide: information.loadingSide,
      machineType: information.machineType,
      maker: information.maker,
      model: information.model,
      lockSerialNo: information.lockSerialNo,
      machineSerialNo: information.machineSerialNo,
      barcode: information.barcode,
      siteLimit: information.siteLimit,
      distanceFromBase: information.distanceFromBase,
      coLocatedGroupNo: information.coLocatedGroupNo,
      numberOfCassettes: information.numberOfCassettes,
      requiresCashierCount: information.requiresCashierCount,
      requiresEVhr: information.requiresEVhr,
      hasSecurityAlarm: information.hasSecurityAlarm,
      alarmDetails: information.alarmDetails,
      country: information.country,
      state: information.state,
      emirate: information.emirate,
      city: information.city,
      address: information.address,
      longitude: information.longitude,
      latitude: information.latitude,
      lockInstallationDate: information.lockInstallationDate,
      firstServiceDate: information.firstServiceDate,
      decomissionedDate: information.decomissionedDate,
      followStandardModels: information.followStandardModels,
      followStandardDenominations: information.followStandardDenominations,
      followStandardCassettes: information.followStandardCassettes,
      dedicatedSerials: information.dedicatedSerials,
      serviceDays: information.serviceDays,
      allowedDays: information.allowedDays,
      numberOfBins: information.numberOfBins || 0,
      numberOfKeys: information.numberOfKeys || 0,
      hasCamera: information.hasCamera || 0,
      cameraType: information.cameraType || "",
      area: information.area || "",
      machineInstallationDate:
        information.machineInstallationDate || new Date(),
    };
    setServicePoint({ ...servicePoint, ..._servicePoint });
  };

  const updateOnwardLocations = (locations) => {
    setServicePoint({
      ...servicePoint,
      onwardLocations: locations,
    });
  };

  const getSiteSLAs = useMemo(() => {
    return Array.isArray(servicePoint.siteSLAs) ? servicePoint.siteSLAs : [];
  }, [servicePoint.siteSLAs]);

  const setSiteSLAs = (data) => {
    const slas = Array.isArray(data)
      ? data
      : Array.isArray(data?.SLAs)
        ? data.SLAs
        : [];

    setServicePoint((prev) => ({
      ...prev,
      siteSLAs: slas.map((sla) => ({
        serviceType: sla.serviceType,
        activityType: sla.activityType,
        responseTime: sla.responseTime,
        attendedTime: sla.attendedTime,
        resolutionTime: sla.resolutionTime,
      })),
      followsCustomerSla:
        typeof data?.followsCustomerSla === "boolean"
          ? data.followsCustomerSla
          : prev.followsCustomerSla,
    }));
  };

  const getServiceWindows = useMemo(() => {
    return Array.isArray(servicePoint.serviceWindows)
      ? servicePoint.serviceWindows
      : [];
  }, [servicePoint.serviceWindows]);

  const setServiceWindows = (data) => {
    setServicePoint((prev) => ({
      ...prev,
      followsCustomerServiceWindow:
        data?.followsCustomerServiceWindow ?? prev.followsCustomerServiceWindow,
      serviceWindows: Array.isArray(data?.serviceWindows)
        ? data.serviceWindows
        : [],
    }));
  };
  // const updateReplenishmentModels = (replenishmentModels) => {
  //   const _servicePoint = {
  //     ...servicePoint,
  //     replenishmentModels,
  //   };
  //   setServicePoint(_servicePoint);
  // };

  // const getReplenishmentModels = useMemo(
  //   () =>
  //     servicePoint.replenishmentModels.map((elm) => ({
  //       ...elm,
  //       expanded: false,
  //     })),
  //   [servicePoint],
  // );
  // const setCassettes = (cassettes) => {
  //   const _servicePoint = {
  //     ...servicePoint,
  //     cassettes,
  //   };
  //   setServicePoint(_servicePoint);
  // };
  // const getCassettes = useMemo(
  //   () => [...servicePoint.cassettes],
  //   [servicePoint],
  // );
  const setDenominations = (denominations) => {
    const _servicePoint = {
      ...servicePoint,
      denominations,
    };
    setServicePoint(_servicePoint);
  };

  const getDenominations = useMemo(
    () => [...servicePoint.denominations],
    [servicePoint],
  );
  const getSiteRepresentatives = useMemo(
    () => [...servicePoint.siteRepresentatives],
    [servicePoint],
  );
  const setSiteRepresentatives = (siteRepresentatives) => {
    const _servicePoint = {
      ...servicePoint,
      siteRepresentatives,
    };
    setServicePoint(_servicePoint);
  };

  const setScheduledServices = (data) => {
    const _servicePoint = {
      ...servicePoint,
      serviceSchedules: data,
    };
    setServicePoint({ ..._servicePoint });
  };

  useEffect(() => {
    if (activeStep === 1 && triggerValidation) {
      trigger();
    } else if (activeStep !== 1 && triggerValidation) {
      setTriggerValidation(false);
    }
  }, [triggerValidation, activeStep]);
  return (
    <>
      {gettingCashCenterList ||
      editingRequest ||
      gettingCustomerList ||
      gettingCountriesList ||
      gettingLocation ||
      gettingRoutesList ||
      gettingMakersList ||
      gettingModelsList ||
      gettingCurrencyList ||
      gettingMachineList ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Service Points", link: Paths.locations },
            { text: "Edit Service Point", isCurrentPage: true },
          ]}
        />
        <Stepper index={activeStep} size="sm" className="extra-small-stepper">
          {steps.map((step, index) => (
            <Step
              key={index}
              // onClick={() => {
              //   if (activeStep === 1) {
              //     updateServicePointInformation(getValues());
              //   }
              //   setActiveStep(index + 1);
              // }}
            >
              <StepIndicator style={{ cursor: "pointer" }}>
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <div style={{ cursor: "pointer" }}>
                <StepTitle>{step.title}</StepTitle>
                <StepDescription>{step.description}</StepDescription>
              </div>

              <StepSeparator />
            </Step>
          ))}
        </Stepper>
        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div className="add-location-form">
                {activeStep === 1 ? (
                  (params.locationId && servicePoint.locationId) ||
                  !params.locationId ? (
                    <form>
                      <Information
                        servicePointInformation={getServicePointInformation}
                        customerList={customerListRes?.data || []}
                        cashCenters={cashCenterList?.data || []}
                        makersList={makersListRes?.data || []}
                        machineList={machineListRes?.data || []}
                        countriesList={countriesListRes?.data || []}
                        editing={Boolean(params.locationId)}
                        isValid={isValid}
                        onMakerChange={(value) => {
                          if (value) {
                            getModelsList(value);
                          }
                        }}
                        handleSubmit={handleSubmit}
                        control={control}
                        errors={errors}
                        watch={watch}
                        resetField={resetField}
                        setValue={setValue}
                        reset={reset}
                        getValues={getValues}
                        modelsList={modelsListRes?.data || []}
                        onNextStep={() => {
                          setActiveStep(2);
                          updateServicePointInformation(getValues());
                        }}
                      />
                    </form>
                  ) : (
                    <></>
                  )
                ) : activeStep === 2 ? (
                  <OnwardLocations
                    addedLocations={servicePoint.onwardLocations}
                    isValid={servicePoint?.onwardLocations?.length}
                    onAddLocations={updateOnwardLocations}
                    onNextStep={() => {
                      setActiveStep(3);
                    }}
                    onPrevStep={() => {
                      setActiveStep(1);
                    }}
                  />
                ) : activeStep === 3 ? (
                  <Denominations
                    currencies={currencyListRes?.data || []}
                    disabled={watch("followStandardDenominations")}
                    followStandardDenominations={watch(
                      "followStandardDenominations",
                    )}
                    toggleStandardDenominations={() => {
                      const _value = !watch("followStandardDenominations");

                      setValue("followStandardDenominations", _value);
                    }}
                    denominations={getDenominations}
                    onNextStep={(denominations) => {
                      setActiveStep(4);
                      setDenominations(denominations);
                    }}
                    onPrevStep={(denominations) => {
                      setActiveStep(2);
                      setDenominations(denominations);
                    }}
                    addData={(data) => {
                      setDenominations(data);
                    }}
                    isValid={isValid}
                  />
                ) : activeStep === 4 ? (
                  <>
                    {/* <OperationalWindow
                      operationalWindows={getOperationalWindows}
                      onValidityChange={setHasOperationalFields}
                      isNextEnabled={isNextEnabled}
                      onNextStep={(data) => {
                        setOperationalWindows(data);
                        setActiveStep(5);
                      }}
                      onPrevStep={(data) => {
                        setOperationalWindows(data);
                        setActiveStep(3);
                      }}
                      addData={(data) => {
                        setOperationalWindows(data);
                      }}
                    /> */}

                    <ServiceWindow
                      initialServiceWindows={getServiceWindows}
                      locationSlaDefaults={locationSlaDefaults}
                      initialFollowsCustomerServiceWindow={
                        servicePoint.followsCustomerServiceWindow
                      }
                      addData={setServiceWindows}
                      onPrevStep={() => setActiveStep(3)}
                      onNextStep={() => setActiveStep(5)}
                    />

                    <SiteSLAs
                      initialSLAs={getSiteSLAs}
                      initialFollowsCustomerSla={
                        servicePoint.followsCustomerSla
                      }
                      locationSlaDefaults={locationSlaDefaults}
                      addData={setSiteSLAs}
                      onPrevStep={(data) => {
                        setSiteSLAs(data);
                        setActiveStep(3);
                      }}
                      onNextStep={(data) => {
                        setSiteSLAs(data);
                        setActiveStep(5);
                      }}
                    />
                  </>
                ) : activeStep === 5 ? (
                  <SiteRepresentative
                    siteRepresentatives={getSiteRepresentatives}
                    onNextStep={(siteRepresentatives) => {
                      setSiteRepresentatives(siteRepresentatives);
                      if (isValid) {
                        setActiveStep(6);
                      } else {
                        setActiveStep(1);
                        setTriggerValidation(true);
                      }
                    }}
                    onPrevStep={(siteRepresentatives) => {
                      setActiveStep(4);
                      setSiteRepresentatives(siteRepresentatives);
                    }}
                    addData={(data) => {
                      setSiteRepresentatives(data);
                    }}
                  />
                ) : activeStep === 6 ? (
                  <ScheduledService
                    cashCenterId={servicePoint?.cashCenterId}
                    serviceSchedules={servicePoint?.serviceSchedules}
                    onNextStep={(data) => {
                      setActiveStep(7);
                      setScheduledServices(data);
                    }}
                    onPrevStep={(data) => {
                      setActiveStep(5);
                      setScheduledServices(data);
                    }}
                  />
                ) : activeStep === 7 ? (
                  <Summary
                    servicePoint={servicePoint}
                    onAddServicePoint={(data) => {
                      addLocation(data);
                    }}
                    editing
                    onPrevStep={() => {
                      setActiveStep(6);
                    }}
                  />
                ) : (
                  <></>
                )}
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
